import { FileDown, FileText } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const formatBytes = (bytes) => {
  if (!bytes) return "";
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1048576) return `${(bytes / 1024).toFixed(1)} KB`;
  return `${(bytes / 1048576).toFixed(1)} MB`;
};

const DocumentDownload = ({ fileId, fileName, fileSize, mimeType, serveUrl }) => {
  const downloadUrl = serveUrl || `${API}/files/${fileId}/serve`;

  return (
    <Card className="h-full min-h-[40vh] flex items-center justify-center border-[var(--xl-line)]" data-testid="document-download">
      <CardContent className="flex flex-col items-center text-center gap-4 py-8 px-4 max-w-md">
        <div className="w-16 h-16 rounded-2xl bg-[var(--xl-primary-soft)] flex items-center justify-center">
          <FileText className="w-8 h-8 text-[var(--xl-primary)]" />
        </div>
        <div className="space-y-1">
          <p className="text-sm font-medium text-[var(--xl-text)] break-all">{fileName || "Document"}</p>
          {fileSize != null && (
            <p className="text-xs text-[var(--xl-mut)]">{formatBytes(fileSize)}</p>
          )}
          {mimeType && (
            <p className="text-[10px] text-[var(--xl-mut)]">{mimeType}</p>
          )}
        </div>
        <Button asChild className="gap-2">
          <a href={downloadUrl} download={fileName || true} target="_blank" rel="noopener noreferrer">
            <FileDown className="w-4 h-4" />
            Download
          </a>
        </Button>
      </CardContent>
    </Card>
  );
};

export default DocumentDownload;
